/* Great Store theme */
(function () {
  'use strict';

  var T = window.theme || {};
  var root = document.documentElement;

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var format = T.moneyFormat || '${{amount}}';
    function digits(c, precision, thousands, decimal) {
      var n = (c / 100).toFixed(precision).split('.');
      var whole = n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return n[1] ? whole + decimal + n[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return digits(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return digits(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return digits(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return digits(cents, 2, "'", '.');
        default: return digits(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- mobile navigation ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
        navToggle.focus();
      }
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    root.classList.add('has-overlay');
    var close = drawer.querySelector('[data-drawer-close].link-btn');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    root.classList.remove('has-overlay');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-link]');
    if (link && drawer && T.cartType === 'drawer') {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-cart-count-title]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  function refreshCart(open) {
    var cartReq = fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });

    if (T.cartType !== 'drawer' || !drawer) {
      return cartReq.then(function (cart) { setCount(cart.item_count); });
    }

    var sectionReq = fetch(T.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); });
    return Promise.all([cartReq, sectionReq]).then(function (results) {
      var cart = results[0];
      var html = results[1]['cart-drawer'];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-body]');
      var current = drawer.querySelector('[data-cart-drawer-body]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      setCount(cart.item_count);
      if (open) openDrawer();
    });
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (button && button.disabled) return;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if (errorEl) errorEl.hidden = true;

    fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || T.strings.error);
        }
        if (T.cartType === 'drawer' && drawer) return refreshCart(true);
        window.location.href = T.routes.cart;
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message || T.strings.error; errorEl.hidden = false; }
      })
      .then(function () {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
  });

  /* ---------- cart line changes ---------- */
  function changeLine(line, quantity) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0) })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        return refreshCart(false);
      });
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      changeLine(step.dataset.line, Number(step.dataset.quantity) + Number(step.dataset.qtyStep));
      return;
    }
    var remove = e.target.closest('[data-remove]');
    if (remove) changeLine(remove.dataset.line, 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) changeLine(input.dataset.line, input.value);
  });

  /* ---------- product page ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('form');
    var variantsEl = section.querySelector('[data-variants]');
    if (!form || !variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceBlock = section.querySelector('[data-price-block]');
    var slides = section.querySelectorAll('[data-slide]');
    var thumbs = section.querySelectorAll('[data-thumb]');

    function showMedia(id) {
      var found = false;
      slides.forEach(function (s) { if (String(s.dataset.mediaId) === String(id)) found = true; });
      if (!found) return;
      slides.forEach(function (s) { s.hidden = String(s.dataset.mediaId) !== String(id); });
      thumbs.forEach(function (t) {
        if (String(t.dataset.mediaId) === String(id)) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
    });

    function selectedOptions() {
      var values = [];
      form.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        values[Number(fs.dataset.optionIndex)] = checked ? checked.value : null;
      });
      return values;
    }

    function updatePrice(variant) {
      if (!priceBlock) return;
      var current = priceBlock.querySelector('[data-price]');
      var compare = priceBlock.querySelector('[data-compare-price]');
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (current) current.textContent = formatMoney(variant.price);
      if (compare) {
        compare.hidden = !onSale;
        compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      priceBlock.classList.toggle('price--sale', !!onSale);
    }

    function onOptionChange() {
      var chosen = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = T.strings.unavailable;
        return;
      }

      idInput.value = variant.id;
      updatePrice(variant);
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      if (variant.featured_media) showMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', onOptionChange);
    });

    var qty = form.querySelector('[data-form-qty]');
    form.querySelectorAll('[data-form-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = (Number(qty.value) || 1) + Number(btn.dataset.formQtyStep);
        qty.value = Math.max(1, next);
      });
    });
  });

  /* ---------- related products ---------- */
  document.querySelectorAll('[data-recs]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.children.length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- collection filters ---------- */
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    var filters = filterForm.querySelector('[data-filters]');
    if (filters && !window.matchMedia('(min-width: 990px)').matches) filters.open = false;

    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-auto-submit]')) {
        filterForm.requestSubmit();
      }
    });
  }
})();

/* ---------- 3D cylinders: only animate while on screen ---------- */
(function () {
  var scenes = document.querySelectorAll('[data-cyl-scene]');
  if (!scenes.length) return;
  if (!('IntersectionObserver' in window)) {
    scenes.forEach(function (el) { el.classList.add('is-in-view'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('is-in-view', entry.isIntersecting);
    });
  }, { rootMargin: '80px' });
  scenes.forEach(function (el) { io.observe(el); });
})();
